import {
  Button,
  Flex,
  Heading,
  Square,
  Stack,
  Loader,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { useInProgressModalAnalytics } from 'src/components/selfService/features/OrderHistory/ZipDownload/hooks/InProgressModalAnalytics';

export interface IInProgressModalProps {
  onClose: () => void;
}

export function InProgressModal({
  onClose,
}: IInProgressModalProps): JSX.Element {
  const { sendAnalyticsBefore } = useInProgressModalAnalytics();
  return (
    <Modal size="xs">
      <Square inset="md">
        <Stack y="x-sm">
          <Heading variant="h1">Download in progress</Heading>
        </Stack>
        Your receipts will be downloaded as a zip file to your device.
        <Stack y="lg">
          <Flex justifyContent="center">
            <Loader size="md" />
          </Flex>
        </Stack>
        <Stack width="100%">
          <Button
            block
            variant="secondary"
            buttonSize="medium"
            onClick={() =>
              sendAnalyticsBefore(onClose, {
                eventaction: 'in progress receipts download _cta',
              })
            }
          >
            Close
          </Button>
        </Stack>
      </Square>
    </Modal>
  );
}
